/* subscription-pills.js
   - Keeps heading as "Delivery Frequency" (even after variant changes)
   - Maintains pill selected state (adds .is-checked for Safari)
*/

(function(){
  const HEADING_TEXT = 'Delivery Frequency';

  function renameHeading(container){
    const lbl = container.querySelector('.shopify_subscriptions_purchase_option_wrapper label');
    if (!lbl) return;
    if (lbl.textContent.trim() !== HEADING_TEXT) lbl.textContent = HEADING_TEXT;
  }

  function applyPillState(container){
    // highlight the selected radio as a pill (.is-checked for older browsers)
    container.querySelectorAll('.shopify_subscriptions_app_block_label_children').forEach(list => {
      const labels = Array.from(list.querySelectorAll('label'));
      const radios  = labels.map(l => l.querySelector('input[type="radio"]')).filter(Boolean);
      function sync(){
        labels.forEach(l => l.classList.remove('is-checked'));
        const checked = radios.find(r => r.checked);
        if (checked){
          const lab = checked.closest('label');
          if (lab) lab.classList.add('is-checked');
        }
      }
      sync();
      radios.forEach(r => r.addEventListener('change', sync));
    });
  }

  function refresh(container){
    // run both on any render
    renameHeading(container);
    applyPillState(container);
  }

  function boot(){
    document.querySelectorAll('.shopify_subscriptions_app_container').forEach(c => {
      refresh(c);

      // Observe re-renders from the app
      const mo = new MutationObserver(() => {
        // small debounce
        clearTimeout(c.__subsWatchTimer);
        c.__subsWatchTimer = setTimeout(() => refresh(c), 50);
      });
      mo.observe(c, { childList:true, subtree:true });

      // Also react to variant changes on the product form
      const form = c.closest('form[action*="/cart/add"]');
      if (form){
        form.addEventListener('change', e => {
          if (e.target && e.target.name === 'id'){
            // the app re-renders asynchronously; enforce heading a few times
            let tries = 0;
            const iv = setInterval(() => {
              refresh(c);
              if (++tries > 10) clearInterval(iv);
            }, 80);
          }
        });
      }
    });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();